export default "__VITE_PUBLIC_ASSET__f6269f67__"